"use client"

export default function PageNotFound() {
  return (
    <div className="w-full min-h-screen flex justify-center items-center">
      <div className="w-full flex flex-col justify-center items-center gap-8 px-6 xxl:px-0 mx-6 xxl:ps-0">
        <h1 className="font-gilroy font-bold text-2xl tracking-normal">
          Page Not Found
        </h1>
      </div>
    </div>
  )
}
